import { FC } from 'react';
import { Divider, Icon } from 'learning-panel-components';
import styles from './downloadHubAlert.module.scss';

const DownloadHubAlert: FC<DownloadHubAlertProps> = (props: DownloadHubAlertProps) => {
    const { message, action, actionMessage, actionIcon, closeDownloadHubAlert } = props;
    return (
        <div className={styles.wrapper}>
            <div>{message}</div>
            {action && (
                <>
                    <div className={styles['action-wrapper']}>
                        <Divider orientation="horizontal" className={styles.divider} color="rgba(98, 98, 98, 0.30)" />
                        <div onClick={() => action()} className={styles.action}>
                            <Icon name={actionIcon} className={styles.icon} />
                            <div>{actionMessage}</div>
                        </div>
                    </div>
                </>
            )}
            <Icon onClick={closeDownloadHubAlert} name="cancel" className={styles.close} />
        </div>
    );
};

interface DownloadHubAlertProps {
    message: string;
    action?: Function;
    actionMessage?: string;
    actionIcon?: string;
    closeDownloadHubAlert: Function;
}

export default DownloadHubAlert;
